import React from 'react';
import {
  Wrench,
  PersonStanding,
  HandHelping,
  AirVent,
  Plug,
  Dumbbell,
  School2,
  PaintRoller,
  Sparkle,
  PawPrint,
  Laptop,
  Toilet,
  Truck,
  Dog,
  Baby,
  Lightbulb,
  Fan,
  Radiation,
  Droplet,
  Thermometer,
  ShieldAlert,
  Bolt,
  Stethoscope,
  Syringe,
  ChefHat,
  Fish,
  Feather,
  Bone,
  MoveRight,
  Boxes,
  Luggage,
  Navigation,
  ShoppingCart,
  CreditCard,
  BadgeCheck,
  ClipboardCheck,
  BrainCircuit,
  HeartPulse,
  Pill,
  Apple,
  BookOpen,
  PenLine,
  GraduationCap,
  Presentation,
  Monitor,
  Server,
  Code,
  Cloud,
  Database,
  Compass,
  Landmark,
  Flag,
  Languages,
  Route,
  Star,
  Check,
  AlertCircle,
  Info,
  Search,
  ChevronDown,
} from 'lucide-react';

export type IconComponent = React.ComponentType<{ className?: string; title?: string }>;

export const iconMap: Record<string, IconComponent> = {
  Wrench,
  PersonStanding,
  HandHelping,
  AirVent,
  Plug,
  Dumbbell,
  School2,
  PaintRoller,
  Sparkle,
  PawPrint,
  Laptop,
  Toilet,
  Truck,
  Dog,
  Baby,
  Lightbulb,
  Fan,
  Radiation,
  Droplet,
  Thermometer,
  ShieldAlert,
  Bolt,
  Stethoscope,
  Syringe,
  ChefHat,
  Fish,
  Feather,
  Bone,
  MoveRight,
  Boxes,
  Luggage,
  Navigation,
  ShoppingCart,
  CreditCard,
  BadgeCheck,
  ClipboardCheck,
  BrainCircuit,
  HeartPulse,
  Pill,
  Apple,
  BookOpen,
  PenLine,
  GraduationCap,
  Presentation,
  Monitor,
  Server,
  Code,
  Cloud,
  Database,
  Compass,
  Landmark,
  Flag,
  Languages,
  Route,
  Star,
  Check,
  AlertCircle,
  Info,
  Search,
  ChevronDown,
};

export default iconMap;
